import UnitMeasurementMdl from '@/models/Warehouse/WhUnitOfMeasurement'
const fetchAllUnitMeasurement = async function(){
    try{
        let unitMeasurement = await UnitMeasurementMdl.params({
            get_all_results : true
        }).get()
        return unitMeasurement.data
    }
    catch(error){
        return error.response.data
    }
}

export default {
    fetchAllUnitMeasurement,
    fetchAll: fetchAllUnitMeasurement,
}